import { render, staticRenderFns } from "./FeedbackManuscriptModeSelectionDialog.vue?vue&type=template&id=1a72a5a0&scoped=true"
import script from "./FeedbackManuscriptModeSelectionDialog.vue?vue&type=script&lang=ts"
export * from "./FeedbackManuscriptModeSelectionDialog.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackManuscriptModeSelectionDialog.vue?vue&type=style&index=0&id=1a72a5a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a72a5a0",
  null
  
)

export default component.exports